// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GamesList_wrapper_15yEt","gameCard":"GamesList_gameCard_24bYK","spinner":"GamesList_spinner_2gFlP"};